import { PAYMENT_REQUEST_FAILED } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case PAYMENT_REQUEST_FAILED:
      return action.payload;
    default:
      return state;
  }
};
